!function () {
	"use strict";
	const videoTemplateSelector = "[data-video-template]",
		loadingClass = "is-loading",
		videoIdAttr = "data-video-id",
		autoplayAttr = "data-video-autoplay";

	if (!customElements.get("video-background")) {
		customElements.define("video-background", class extends HTMLElement {
			constructor() {
				super();
			}
			connectedCallback() {
				this.videoId = this.getAttribute(videoIdAttr);
				this.videoTemplate = this.querySelector(videoTemplateSelector);
				this.video = null;
				this.autoplay = this.getAttribute(autoplayAttr) === "true"; 

				this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this);
				if (this.videoId) this.renderVideo();
			}
			powerSaverVideoPlay() {
				if (this.video && this.video.tagName.toLowerCase() === "video") {
					this.video.play();
				}
			}
			renderVideo() {
				this.videoTemplateObserver = new IntersectionObserver((entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							const templateHTML = this.videoTemplate.innerHTML;
							this.innerHTML = templateHTML;
							this.classList.remove(loadingClass);
							this.video = this.querySelector("video") || this.querySelector("iframe");

							if (this.video) {
								if (this.video.tagName.toLowerCase() === "iframe") {
									this.disableCaptions(this.video);
									this.fixIframeAutoplay(this.video);
								} else if (this.video.tagName.toLowerCase() === "video") {
									if (this.getAttribute('data-video-autoplay') !== "false") {
										this.observeVideoPlayToggle();
										if (this.autoplay) {
											this.video.play().catch(() => {
												document.addEventListener("click", this.powerSaverVideoPlay, { passive: true, bubbles: true, once: true });
												document.addEventListener("touchstart", this.powerSaverVideoPlay, { passive: true, bubbles: true, once: true });
											});
										}
									} else {
										this.toogleVideoButtons();
									}
								}
							}
							observer.unobserve(entry.target);
						}
					});
				}, { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
				this.videoTemplateObserver.observe(this);
			}
			disableCaptions(iframe) {
				let src = iframe.getAttribute("src");
				if (src) {
					src = src.replace(/(&|\?)cc_load_policy=\d+/g, "");
					src += (src.includes("?") ? "&" : "?") + "cc_load_policy=0&cc_lang_pref=&hl=en";
					iframe.setAttribute("src", src);
				}
			}

			fixIframeAutoplay(iframe) {
				let src = iframe.getAttribute("src");
				if (src) {
					src = src.replace(/autoplay=1/, "autoplay=0"); 
					if (!this.autoplay) {
						iframe.setAttribute("src", src);
					}
				}
			}

			observeVideoPlayToggle() {
				if (!this.video || this.video.tagName.toLowerCase() !== "video") return;
				this.videoPlayObserver = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						const isVisible = entry.isIntersecting;
						if (this.autoplay) {
							if (isVisible && typeof this.video.play === "function") {
								this.video.play().catch(() => { });
							}
						}
						if (!isVisible && typeof this.video.pause === "function") {
							this.video.pause();
						}
					});
				}, { rootMargin: "0px", threshold: [0, 1] });
				this.videoPlayObserver.observe(this.video);
			}

			// toogleVideoButtons() {
			// 	const sectionElement = this.closest('section');
			// 	if (sectionElement) {
			// 		const buttonsContainer = sectionElement.querySelector('.video__buttons');
			// 		if (buttonsContainer) {
			// 			const playButton = buttonsContainer.querySelector('[data-play]');
			// 			const pauseButton = buttonsContainer.querySelector('[data-pause]');

			// 			buttonsContainer.addEventListener('click', () => {
			// 				if (this.video) {
			// 					this.video.paused ? this.playVideo(buttonsContainer) : this.pauseVideo(buttonsContainer);
			// 				}
			// 			});

			// 			if (playButton && pauseButton) {
			// 				playButton.addEventListener('click', () => this.video.paused && this.playVideo(buttonsContainer));
			// 				pauseButton.addEventListener('click', () => !this.video.paused && this.pauseVideo(buttonsContainer));
			// 			}
			// 		}
			// 	}
			// }
			toogleVideoButtons() {
				const sectionElement = this.closest('section');
				if (sectionElement) {
					const buttonsContainer = sectionElement.querySelector('.video__buttons');
					if (buttonsContainer) {
						buttonsContainer.addEventListener('click', (event) => {
							const playButton = event.target.closest('[data-play]');
							const pauseButton = event.target.closest('[data-pause]');

							if (this.video) {
								if (playButton && this.video.paused) {
									this.playVideo(buttonsContainer);
								} else if (pauseButton && !this.video.paused) {
									this.pauseVideo(buttonsContainer);
								} else {
									this.video.paused ? this.playVideo(buttonsContainer) : this.pauseVideo(buttonsContainer);
								}
							}
						});
					}
				}
			}


			playVideo(buttonsContainer) {
				this.video.play();
				this.video.muted = false;
				buttonsContainer.classList.remove('pause');
				buttonsContainer.classList.add('play');
			}

			pauseVideo(buttonsContainer) {
				this.video.pause();
				this.video.muted = true;
				buttonsContainer.classList.remove('play');
				buttonsContainer.classList.add('pause');
			}

			disconnectedCallback() {
				if (this.videoTemplateObserver) this.videoTemplateObserver.disconnect();
				if (this.videoPlayObserver) this.videoPlayObserver.disconnect();
				if (this.videoId) {
					document.removeEventListener("click", this.powerSaverVideoPlay);
					document.removeEventListener("touchstart", this.powerSaverVideoPlay);
				}
			}
		});
	}
}();
